import type { FC } from 'react'

import { FilterTabs } from '@skytech/ui/FilterTabs'
import { getEntries, getWhiteLabelForDealerStyle } from '@skytech/utils'

import { useAppContext } from '@/App.context'
import { useSearchParamsByKey } from '@/hooks/searchParams'

import { Translation } from '../i18n/Translation'

import type { OrderStatusCount } from './resources'

export const StatusTabs: FC<{
  statusCounter: OrderStatusCount
}> = ({ statusCounter }) => {
  const { whiteLabel } = useAppContext()

  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status', 'open')
  const whiteLabelForDealerStyle = getWhiteLabelForDealerStyle(whiteLabel)

  return (
    <FilterTabs className="hidden overflow-x-auto md:flex">
      {getEntries(statusCounter)
        .filter(([, counter]) => counter > 0)
        .map(([status, counter]) => {
          const parsedStatus = status === 'completed' ? 'done' : status
          return (
            <FilterTabs.Button
              className="flex items-center justify-center gap-1 whitespace-normal break-words capitalize"
              whiteLabel={whiteLabelForDealerStyle}
              filterName={<Translation id={`STATUS_SUBSCRIPTION_ORDER/${parsedStatus}`} />}
              isSelected={status === queryStatus}
              counter={counter}
              key={status}
              onClick={() => setQueryStatus(status)}
            />
          )
        })}
    </FilterTabs>
  )
}
